export type NavItem =
  | { id: string; label: string; kind: 'section'; sectionId: string }
  | {
      id: string;
      label: string;
      kind: 'route';
      to: string;
      emphasis?: boolean;
    };

export const NAV_ITEMS: readonly NavItem[] = [
  { id: 'services', label: 'サービス', kind: 'section', sectionId: 'services' },
  {
    id: 'engagement',
    label: '関わり方',
    kind: 'section',
    sectionId: 'engagement',
  },
  {
    id: 'message',
    label: '代表コメント',
    kind: 'section',
    sectionId: 'message',
  },
  {
    id: 'company-info',
    label: '会社概要',
    kind: 'section',
    sectionId: 'company-info',
  },
  { id: 'news', label: 'お知らせ', kind: 'section', sectionId: 'news' },
  {
    id: 'contact',
    label: '相談する →',
    kind: 'route',
    to: '/contact',
    emphasis: true,
  },
];
